import UpdateButton, { UpdateButtonTemplate } from './UpdateButton';

export default UpdateButton;
export { UpdateButtonTemplate };
